export const ONETRUST_CONSENT_COOKIE = 'OptanonConsent';

export const GEOLOCATION_COOKIES = {
  ORIGIN_COUNTRY: 'originCountry',
  HIDE_GEOLOCATION_MODAL: 'hideGeoLocationModal',
};

export const OPTIMIZELY_USER_COOKIE = 'optimizely_experiment_user';

/**
 * For use with the `Domain` cookie option. Includes the current top-level
 * domain and its subdomains.
 */
export const DOMAIN_INCLUDING_SUBDOMAINS =
  process.env.NEXT_PUBLIC_TLD && `.${process.env.NEXT_PUBLIC_TLD}`;
